import { Layers } from "appworks/graphics/layers/layers";
import { AbstractControl } from "appworks/ui/controls/abstract-control";
import { AutoStopControlFactory } from "appworks/ui/factories/autoplay/auto-stop-control-factory";
import { AgsCancelAutoControl } from "../ags-cancel-auto-control";

export class AgsAutoStopControlFactory extends AutoStopControlFactory {
    public build(layer: Layers): AbstractControl[] {
        return [new AgsCancelAutoControl(layer.getFlexiButton("autoplay_stop_button"))];
    }
}
